const getData = state => state.orders || {};
const getOrders = state => getData(state).orders || [];
const getOfflineOrders = state => getData(state).offlineOrders || [];
const getOfflinePagination = state => getData(state).additionalPagination || {};
const getPaginatedOrders = state => getOfflinePagination(state).offlineOrders || [];
const getCode = state => getData(state).selectedOrder;
const getAnyLoyalty = state => getData(state).anyLoyalty || false;
const getOrdersForExtService = (state, eventType) =>
    getData(state).ordersForExtService[eventType] || {};
const getOrderDetailForExtService = (state, eventType) =>
    getData(state).orderDetailForExtService[eventType] || {};
const getSubjectValue = state =>
    state['personal-information'] && state['personal-information'].data
        ? state['personal-information'].data.subject
            ? state['personal-information'].data.subject.value
            : ''
        : '';

export default {
    getData,
    getOrders,
    getOfflineOrders,
    getPaginatedOrders,
    getCode,
    getAnyLoyalty,
    getOrdersForExtService,
    getOrderDetailForExtService,
    getSubjectValue,
    getOfflinePagination,
};
